import React from 'react';
import { 
    SearchContainer, 
    SearchInput, 
    SearchIcon,
    ActivateSearch
} from './styles';
import searchIcon from './searchIcon.svg';

const AtsSearchBar = ({ 
    searchString, 
    setSearchString, 
    activeSearch = true, 
    setActiveSearch,
    searchHandler
}) => {
    if(!activeSearch) {
        return (
            <ActivateSearch onClick={()=>setActiveSearch(true)}>
                <SearchIcon style={{margin: '0 0px -3px 0'}} src={searchIcon} alt='search' />
            </ActivateSearch>
        )
    }
    return(
        <SearchContainer style={{ margin: '0px'}}>
            <SearchIcon src={searchIcon} alt='search' onClick={() => searchHandler()} style={{cursor: 'pointer'}}/>
            <SearchInput 
                placeholder="Search..."
                type="text"
                id="search"
                name="search"
                autoComplete='off'
                spellCheck={false}
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                onKeyUp={(e) => {
                    if(searchHandler){
                        if(e.key === 'Backspace') {
                            console.log("target value-===>", e.target.value)
                            console.log("Backspace")
                            searchHandler(e.target.value);
                        } else {
                            searchHandler(e.target.value);
                        }
                    }
                }}
            />
        </SearchContainer>
    )
}

export default AtsSearchBar;